// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'

import Copyright from '../Copyright'
import MainHeader from '../MainHeader'
import GlobalHeader from '../GlobalHeader'
import BuildId from '../BuildId'

import './index.css'

export default class Page extends Component {

  render () {
    return (
      <div className='page-container'>
        <GlobalHeader/>
        <MainHeader/>
        <div className='page-content'>
          {this.props.children}
        </div>
        <div className='footer'>
          <div className='footer-inner row'>
            <div className='col-10'>
              <Copyright/>
            </div>
            <div className='col-2'>
              <BuildId/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
